import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

type ErrorSummaryColumnsProps = {
  order: string,
  sort: string
}

export default function ErrorSummaryColumns({
  order,
  sort,
}: ErrorSummaryColumnsProps): React.Element {
  return (
    <THead>
      <Tr>
        <Th
          field="errorType"
          order={order}
          sort={sort}
          sortable
          >
          Error Type
        </Th>
        <Th
          field="severity"
          order={order}
          sort={sort}
          sortable
          >
          Severity
        </Th>
        <Th>Description</Th>
        <Th
          field="count"
          order={order}
          sort={sort}
          sortable
          style={{ textAlign: 'right' }}
          >
          Count
        </Th>
      </Tr>
    </THead>
  );
}
